import React, { useEffect, useState } from "react";
import "../../../css/MonthTimeRental.css";
import { RentalMonthTime, fetchAsyncRentalMonthTime } from "../RentalSlice";
import { PieChart, Pie, Tooltip, ResponsiveContainer } from "recharts";
import { useDispatch, useSelector } from "react-redux";

const MonthTimeRental = () => {
  const dispatch = useDispatch();
  const RentalMonthTimeData = useSelector(RentalMonthTime);

  const handlePage = (item: number) => {
    setPage(page + item);
  };

  const [page, setPage] = useState(1);

  useEffect(() => {
    // 初回描画時に実行する処理
    dispatch(fetchAsyncRentalMonthTime(page));

    // 定期実行を設定
    const interval = setInterval(() => {
      dispatch(fetchAsyncRentalMonthTime(page));
    }, 60000); // 60秒ごとに実行

    // コンポーネントのクリーンアップ時にインターバルをクリア
    return () => clearInterval(interval);
  }, [dispatch, page]); // 依存配列にdispatchを含める

  return (
    <div className="time_month_container">
      <div className="time_month_title_container">
        <div className="back" onClick={() => handlePage(1)}>
          ←
        </div>
        {RentalMonthTimeData && RentalMonthTimeData.length > 0 && (
          <h2 className="time_month_title">
            時間別レンタル件数/{RentalMonthTimeData![0]["month"]}
          </h2>
        )}{" "}
        {RentalMonthTimeData && RentalMonthTimeData.length < 1 && (
          <h2 className="time_month_title">時間別レンタル件数/</h2>
        )}
        <div
          className="next"
          onClick={() => {
            handlePage(-1);
          }}>
          →
        </div>
      </div>
      <ResponsiveContainer width="100%" height="75%">
        <PieChart className="Piechart">
          <Pie
            data={RentalMonthTimeData!}
            dataKey="count"
            nameKey="time"
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#82ca9d"
            label
          />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MonthTimeRental;
